import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const appointmentsService = {
  // Buscar próximos horários disponíveis para agendamento
  // GET /api/appointments/next-available-slots?professionalId=&serviceId=&placeId=&count=
  getNextAvailableSlots: async (professionalId, serviceId, placeId, count = 3) => {
    const response = await api.get('/appointments/next-available-slots', {
      params: { professionalId, serviceId, placeId, count },
    });
    return extractData(response.data);
  },

  // Atualizar um agendamento (inclui edição de horário no fluxo admin)
  // PUT /api/appointments/{id}
  update: async (id, payload) => {
    const response = await api.put(`/appointments/${id}`, payload);
    return response.data;
  },

  // Buscar agendamentos do profissional que se sobrepõem ao intervalo (apenas AVISO no admin)
  // GET /api/appointments/overlaps?professionalId=&startTime=&endTime=&excludeAppointmentId=
  getOverlaps: async ({ professionalId, startTime, endTime, excludeAppointmentId }) => {
    const response = await api.get('/appointments/overlaps', {
      params: { professionalId, startTime, endTime, excludeAppointmentId },
    });
    return extractData(response.data) || [];
  },
};

export default appointmentsService;
